/** Number and time formatting in plain words (docs/12-ux.md §4 rule 5). */
export const usd = (x: number | null | undefined, digits = 2) =>
  x === null || x === undefined || !Number.isFinite(x) ? "—" : `${x < 0 ? "−" : ""}$${Math.abs(x).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
export const usd0 = (x: number | null | undefined) => usd(x, 0);
export const signedUsd = (x: number | null | undefined, digits = 2) => (x === null || x === undefined || !Number.isFinite(x) ? "—" : `${x >= 0 ? "+" : "−"}${usd(Math.abs(x), digits)}`);
export const pct = (x: number | null | undefined, digits = 1) => (x === null || x === undefined || !Number.isFinite(x) ? "—" : `${x >= 0 ? "+" : "−"}${Math.abs(x).toFixed(digits)}%`);
export const plainPct = (x: number | null | undefined, digits = 1) => (x === null || x === undefined || !Number.isFinite(x) ? "—" : `${x.toFixed(digits)}%`);
export const coin = (s: string) => s.replace(/USDT$|USDC$|FDUSD$/, "");

export function ago(t: number, now = Date.now()): string {
  const s = Math.max(0, Math.round((now - t) / 1000));
  if (s < 60) return "just now";
  const m = Math.round(s / 60); if (m < 60) return `${m} minute${m > 1 ? "s" : ""} ago`;
  const h = Math.round(m / 60); if (h < 48) return `${h} hour${h > 1 ? "s" : ""} ago`;
  const d = Math.round(h / 24); return `${d} days ago`;
}
export const dateUtc = (t: number) => new Date(t).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
export const timeUtc = (t: number) => new Date(t).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) + " UTC";

/** Next 00/08/16 UTC boundary (rebalance and funding). */
export function nextGrid(now = Date.now()): number {
  const H = 3_600_000, h = Math.floor(now / H);
  let k = h + 1; while (new Date(k * H).getUTCHours() % 8 !== 0) k++;
  return k * H;
}
export function until(t: number, now = Date.now()): string {
  const m = Math.max(0, Math.round((t - now) / 60_000));
  return m < 60 ? `in ${m} min` : `in ${Math.floor(m / 60)} h ${m % 60} min`;
}
